import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-wifi",
  templateUrl: "./med-icon-wifi.component.html",
})
export class MedIconWifiComponent extends SvgMixinComponent {}
